import { Types } from "@ioc/types";
import { IHttpService } from "@modules/infra/http/models/IHttpService";
import { inject, injectable } from "inversify";
import { IGetPriceSumService } from "../models/IGetPriceSumService";

@injectable()
export class GetPriceSumService implements IGetPriceSumService {
  // @ts-ignore
  @inject(Types.IHttpService) private httpInstance: IHttpService;

  public async execute(subtotals: string[]): Promise<number> {
    const result = await this.httpInstance.post<{ sum: string }>(
      "/prices/sum",
      subtotals
    );
    const sumValue = result?.sum ?? "0";
    return parseFloat(sumValue) || 0;
  }
}
